// import { useEffect, useRef } from "react";
// import { InfoCircledIcon } from "@radix-ui/react-icons";
// import { Alert, AlertDescription } from "@/components/ui/alert";
// import { AlertCircleRedIcon } from "@/components/Icons/AlertCircleRedIcon";
// import { cn } from "@/lib/utils";
import type { PurchasedCreditsGate } from "../hooks/usePurchasedCreditsGate";

type PurchasedCreditsRequirementProps = {
  gate: PurchasedCreditsGate;
  required: number;
  className?: string;
  /** Scroll the alert into view when it transitions into the blocked state. Defaults to true. */
  scrollIntoViewWhenBlocked?: boolean;
  /**
   * Delay (ms) before scrolling into view. Runs after competing scroll effects on the
   * page (e.g. validation-error scroll, price/layout updates) so it isn't overridden.
   */
  scrollIntoViewDelayMs?: number;
};

/**
 * TEMP: paid-credits requirement banners hidden while the confirm modal covers the
 * cost breakdown. Message helper + gate logic remain for when this is re-enabled.
 *
 * When blocked, shows a destructive alert; when satisfied, shows the requirement as
 * an informational alert.
 */
export const PurchasedCreditsRequirement = ({
  gate,
  required,
  className,
  scrollIntoViewWhenBlocked = true,
  scrollIntoViewDelayMs = 250
}: PurchasedCreditsRequirementProps) => {
  void required;
  void className;
  void scrollIntoViewWhenBlocked;
  void scrollIntoViewDelayMs;
  void gate;
  return null;

  // const alertRef = useRef<HTMLDivElement>(null);
  // const wasBlockedRef = useRef(false);
  //
  // useEffect(() => {
  //   if (gate.isBlocked && !wasBlockedRef.current && scrollIntoViewWhenBlocked) {
  //     const timeoutId = window.setTimeout(() => {
  //       alertRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
  //     }, scrollIntoViewDelayMs);
  //     wasBlockedRef.current = gate.isBlocked;
  //     return () => window.clearTimeout(timeoutId);
  //   }
  //   wasBlockedRef.current = gate.isBlocked;
  // }, [gate.isBlocked, scrollIntoViewWhenBlocked, scrollIntoViewDelayMs]);
  //
  // if (!gate.hasRequirement) {
  //   return null;
  // }
  //
  // if (gate.isBlocked) {
  //   return (
  //     <Alert
  //       ref={alertRef}
  //       variant="destructive"
  //       size="sm"
  //       className={cn("border-red-dark-300/30 bg-[#EF44443D]", className)}
  //     >
  //       <AlertCircleRedIcon className="h-[16px] w-[16px] min-w-[16px]" />
  //       <AlertDescription className="subtext-small text-red-dark-300">
  //         {gate.message}
  //       </AlertDescription>
  //     </Alert>
  //   );
  // }
  //
  // return (
  //   <Alert variant="info" size="sm" className={className}>
  //     <InfoCircledIcon className="h-[16px] w-[16px] min-w-[16px]" />
  //     <AlertDescription className="subtext-small">{gate.message}</AlertDescription>
  //   </Alert>
  // );
};
